<template>
  <div class="box">
    <div class="head" :class="{'pt025':type != 1}">
      <img
        v-if="type == 1"
        class="head-left"
        @click="returnBtn"
        src="../../assets/h5/return.png"
        alt=""
      />
      <div class="head-top title" v-if="!tabSta">
        {{ $t("Webname.recharge") }}
      </div>
      <van-tabs class="head-top" v-model:active="active" v-if="tabSta">
        <van-tab :title="$t('Webname.Withdrawal')"></van-tab>
        <van-tab :title="$t('Webname.Recharge')"></van-tab>
      </van-tabs>
      <img
        class="head-right"
        :class="{'top4':type != 1}"
        @click="langBtn"
        src="../../assets/h5/lang.png"
        alt=""
      />
    </div>

    <div v-if="active == 1" class="box-main">
      <div class="user">
        <img
          v-if="userData.icon"
          class="user-img"
          :src="userData.icon"
          alt=""
        />
        <img
          v-else
          class="user-img"
          src="../../assets/moveabout/fj/mo.png"
          alt=""
        />
        <div class="text">
          <p class="text-1">{{ userData.nickname }}</p>
          <p class="text-2">
            <span>ID:</span><span>{{ userData.id }}</span>
          </p>
        </div>
        <div class="user-id">
          <div @click="addIdBtn" class="add-id">{{ $t("Webname.uid") }}</div>
          <div class="balance" v-if="userData.diamond">
            <div class="balance-txt">{{ $t("Webname.balance") }}</div>
            <div class="dio">
              <div class="diamond">
                <img
                  style="width:20px"
                  src="../../assets/h5/dio.png"
                  alt=""
                />{{
                  userData.diamond
                    ? userData.diamond.toLocaleString()
                    : userData.diamond
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="Diamonds">
        <div
          class="Diamonds-box"
          :class="activeColor == index ? 'active' : ''"
          @click="changePic(item, index)"
          v-for="(item, index) in picList"
          :key="index"
        >
          <div class="sizeimg">
            <img class="sizeimg-img" :src="item.imgUrl" alt="" />
            <p>{{ item.amount.toLocaleString() }}</p>
          </div>
          <span v-if="item.lable != ''" class="lable">{{ item.lable }}</span>
        </div>
      </div>
    </div>
    <div v-if="active == 1" class="int">{{ $t("Webname.self") }}</div>
    <div v-if="active == 1" class="box-bottom">
      <div
        @click="priceBtn(Atem)"
        v-for="Atem in picListData"
        :key="Atem.channelId"
      >
        <div class="bottom-list">
          <div class="bottom-image">
            <img class="bottom-img" :src="Atem.icon" alt="" />
          </div>
          <div class="picnum">
            <div class="picnum-box">
              <div>
                <div v-if="Atem.discount" class="picnumimg">
                  <span class="ctn">{{ Atem.discount }}</span>
                </div>
              </div>
            </div>

            <div class="piccss">
              <div class="labels-text">
                <span class="labels-zt">{{ Atem.currency }}</span>
                <span class="originalPrice">{{
                  (Atem.price / 100).toFixed(2)
                }}</span>
              </div>
              <s v-if="Atem.originalPrice" class="labels-text text-css">
                <span class="labels-zt">{{ Atem.currency }}</span>
                <span class="originalPrice">{{
                  (Atem.originalPrice / 100).toFixed(2)
                }}</span>
              </s>
            </div>

            <img class="labels-img" src="../../assets/h5/right.png" alt="" />
          </div>
        </div>
        <van-divider />
      </div>
    </div>
    <van-popup
      v-if="active == 1"
      class="change-uid"
      v-model:show="showCenter"
      round
      @click-overlay="onClickOverlay"
    >
      <p class="title">{{ $t("Webname.addUid") }}</p>

      <div v-if="userShow">
        <div class="add-uid" @click="addUser">
          <img src="../../assets/h5/add.png" alt="" />
          <p>{{ $t("Webname.addUid") }}</p>
        </div>
        <div
          class="add-user"
          v-for="item in userList"
          :key="item.id"
          @click="changeUid(item)"
        >
          <img v-if="item.icon" :src="item.icon" alt="" />
          <img v-else src="../../assets/moveabout/fj/mo.png" alt="" />
          <div>
            <div class="tx1">{{ item.nickname }}</div>
            <div class="tx2">ID：{{ item.id }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <van-cell-group inset>
          <van-field
            class="uid-ipt"
            input-align="center"
            v-model="userId"
            clearable
            type="digit"
            @clear="clear"
          />
          <div class="prompt">
            <div v-if="txtSta" class="errtxt">
              {{ $t("Webname.err_uid") }}
            </div>
            <div v-if="!txtSta && user" class="username">
              {{ $t("Webname.uuserName") }}{{ user.nickname }}
            </div>
          </div>

          <div
            style="display:flex; justify-content: space-between;margin:15px 0 10px 0"
          >
            <van-button @click="gitUser" class="btn">{{
              $t("Webname.Query")
            }}</van-button>
            <van-button
              :disabled="changeBtn"
              @click="userBtn(2)"
              class="btn2"
              :class="{ newbtn: !changeBtn }"
              >{{ $t("Webname.Confirm") }}</van-button
            >
          </div>
        </van-cell-group>
      </div>
    </van-popup>
    <!-- 圆角弹窗（底部） -->
    <van-popup
      v-model:show="showBottom"
      closeable
      round
      position="bottom"
      class="showBottom"
    >
      <div class="lang-tit">{{ $t("Webname.lang") }}</div>

      <div style="padding:0 20px">
        <div
          class="lang-css"
          v-for="(item, index) in langList"
          :key="index"
          @click="changeLang(item)"
        >
          <div>{{ item.name }}</div>
          <img
            v-if="isLang == item.lang"
            src="../../assets/h5/gou.png"
            alt=""
          />
        </div>
      </div>
    </van-popup>
    <picWithdrawal v-if="active == 0"></picWithdrawal>
  </div>
</template>
<script>
import axios from "axios";
import { Toast } from "vant";
import picWithdrawal from "./picWithdrawal.vue";
export default {
  name: "App",
  components: {
    picWithdrawal,
  },
  data() {
    return {
      activeColor: 0,
      picList: [],
      picListData: [],
      userData: {},
      uid: null,
      headers: null,
      isLang: "",
      userInfo: [],
      userList: [],
      status: false,
      showCenter: false,
      userShow: true,
      userId: "",
      user: "",
      txtSta: false,
      showBottom: false,
      changeBtn: true,
      tabSta: "",
      fieldValue: "",
      options: "",
      cascaderValue: "",
      targetUserId: "",
      langList: [
        { name: "English", lang: "en" },
        { name: "العربية", lang: "ar" },
        { name: "Español", lang: "es" },
        { name: "Português", lang: "pt" },
        { name: "Türkçe", lang: "tr" },
        { name: "简体中文", lang: "zh" },
        { name: "繁体中文", lang: "tc" },
      ],
      active: 1,
      type: "",
      // token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOiJOVFUwIiwieHl6IjoiUTBGRk5VTXhPRFV0UlRJMk1pMDBNREJGTFVFNFFVUXROa0U0T1VSRk9FRXhNVGMyIiwiZXhwIjoxOTEzNzk5NTUwfQ.xvwLcdHT2D5e5KH6siiVqQBRxfN-7Mz6H3KhjLQvVsQ',
      // uid: 554,
      // headers: [
      //   'Content-Type:' + 'application/json; charset=utf-8',
      //   'deviceId:' + 'CAE5C185-E262-400E-A8AD-6A89DE8A1176',
      //   'lang:' + 'zh_CN',
      //   'version:' + '2.1.39',
      //   'os:' + '2',
      //   'model:' + 'model:iPhone_XR_14.8.1',
      //   'fid:' + '0',
      // ],
      deviceId: "",
      isButtonShow: false,
    };
  },
  created() {
    // let payment_url ="http://h5game.koudailive.com/webpage/#/changePic?sharepage=0&type=1&isShowNav=0";
    //type 1:app 2:浏览器
    let payment_url = location.hash;
    let askIndex = payment_url.indexOf("type");
    var newStr = payment_url.slice(askIndex);
    let strs = decodeURIComponent(newStr.split("=")[1])[0];
    this.type = strs;
    if (strs == 1) {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window["getUserInfo"] = (data) => {
        this.getUserInfo(data);
      };
    } else if (strs == 2) {
      this.$router.push({ path: "/withdrawalLogin", query: { type: "2" } });
    } else if (strs == 3) {
      this.gitInfo();
    }
    if (localStorage.getItem("active")) {
      this.active = localStorage.getItem("active");
      localStorage.removeItem("active");
    }
  },
  watch: {
    userId(newval, oldval) {
      if (newval) {
        this.changeBtn = true;
      }
    },
  },
  mounted() {
  },
  methods: {
    changePic(item, index) {
      this.activeColor = index;
      this.picListData = item.clResultList;
    },
    returnBtn() {
      this.$completes.complete("getPreviousPage");
    },
    getUserInfo(data) {
      let that = this;
      this.userInfo = JSON.parse(data);
      this.headers = [
        "Content-Type:" + "application/json; charset=utf-8",
        // "deviceId:" + JSON.parse(data).deviceId,
        "lang:" + JSON.parse(data).lang,
        // "version:" + JSON.parse(data).version,
        "os:" + "3",
        // "model:" + JSON.parse(data).model,
        "fid:" + JSON.parse(data).fid,
        "uid:" + JSON.parse(data).userId,
      ];
      this.token = JSON.parse(data).token;
      this.uid = JSON.parse(data).userId;
      this.targetUserId = this.uid;
      this.deviceId = JSON.parse(data).deviceId;
      let langs = this.userInfo.lang.substring(0, 2);
      let lang = this.userInfo.lang;
      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
          this.isLang = "tc";
        } else {
          this.$i18n.locale = "zh";
          this.isLang = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
        this.isLang = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
        this.isLang = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
        this.isLang = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
        this.isLang = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
        this.isLang = "pt";
      } else {
        this.$i18n.locale = "en";
        this.isLang = "en";
      }
      localStorage.setItem("isLang", this.isLang);
      let obj = {
        token: this.token,
        uid: this.uid,
        deviceId: this.deviceId,
      };
      localStorage.setItem("data", JSON.stringify(obj));
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
      this.identity();
      this.listData();
      this.changeData(this.targetUserId);
    },

    gitInfo() {
      let data = JSON.parse(localStorage.getItem("data"));
      console.log(data, "data");
      this.uid = data.uid;
      this.targetUserId = this.uid;
      this.headers = [
        "lang:" + data.lang,
        "os:" + data.os,
        "fid:" + "0",
        "uid:" + data.uid,
      ];

      let langs = data.lang.substring(0, 2);
      let lang = data.lang;
      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
          this.isLang = "tc";
        } else {
          this.$i18n.locale = "zh";
          this.isLang = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
        this.isLang = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
        this.isLang = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
        this.isLang = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
        this.isLang = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
        this.isLang = "pt";
      } else {
        this.$i18n.locale = "en";
        this.isLang = "en";
      }
      localStorage.setItem("isLang", this.isLang);
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
      this.identity();
      this.listData();
      this.changeData(this.targetUserId);
    },

    identity() {
      let that = this;
      let paramObjs = {
        option: "get",
        host:
          this.$serviceIp +
          "/api/trade/card/tx/checkAuthForWeb?uid=" +
          that.uid,
        data: "",
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        if (data.code == 200) {
          this.tabSta = data.data.result;
        } else {
          Toast(response.data.message || this.$t("transfer.error"));
        }
      });
    },
    listData() {
      let that = this;
      let paramObjs = {
        option: "get",
        host:
          this.$serviceIp +
          "/api/trade/shop/shopKillDiamondsForWeb?uid=" +
          that.uid,
        data: "",
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        if (data.code == 200) {
          this.picList = data.data;

          this.picListData = this.picList[0].clResultList;
        } else {
          Toast(response.data.message || this.$t("transfer.error"));
        }
      });
    },

    changeData(targetUserId) {
      let that = this;
      let paramObjs = {
        option: "get",
        host:
          this.$serviceIp +
          "/api/user/userBaseInfoForWeb?targetUserId=" +
          targetUserId,
        data: "",
        header: JSON.stringify(this.headers),
      };
      this.$server.curlExec(paramObjs).then((data) => {
        if (data.code == 200) {
          this.userData = data.data;
          console.log('data.data',data.data);
          this.userBtn(1)
        } else {
          Toast(data.message || this.$t("transfer.error"));
        }
      });
    },

    priceBtn(Atem) {
      let obj = {};
      if (this.type == 1) {
        obj = this.userInfo;
      } else if (this.type == 3) {
        obj = JSON.parse(localStorage.getItem("data"));
      }
      let that = this;
      axios({
        url: that.$serviceIp + `/api/trade/order/createForWeb`,
        method: "post",
        headers: {
          uid: obj.uid,
          fid: obj.fid || 0,
          os: obj.os || 3,
          lang: obj.lang,
        },
        data: {
          mallId: Atem.outsideId,
          sourceId: "1",
          payType: Atem.clId,
          orderType: "2",
          description: Atem.discount,
          clOutsideId: Atem.clOutsideId,
        },
        params: { uid: that.uid, targetUserId: that.targetUserId },
      }).then((res) => {
        if (res.data.code == 200) {
          window.location.href = res.data.data.url; /* 成功跳转 */
        } else {
          Toast(res.data.message || this.$t("transfer.error"));
        }
      });
    },

    onClickOverlay() {
      this.userShow = true;
      this.txtSta = false;
      this.changeBtn = true;
      this.user = "";
      this.userId = "";
    },
    addIdBtn() {
      let arr = JSON.parse(localStorage.getItem("userList"));
      if (arr) {
        let res = new Map();
        let list = arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
        this.userList = list.reverse();
      }

      this.showCenter = true;
    },

    addUser() {
      this.userShow = false;
      this.user = "";
      this.userId = "";
    },
    gitUser() {
      if (this.userId) {
        let paramObjs = {
          option: "get",
          host:
            this.$serviceIp +
            "/api/user/userBaseInfoForWeb?targetUserId=" +
            this.userId,
          data: "",
          header: JSON.stringify(this.headers),
        };
        this.$server.curlExec(paramObjs).then((data) => {
          if (data.code == 200) {
            this.user = data.data;
            this.txtSta = false;
            this.changeBtn = false;
          } else {
            this.txtSta = true;
            this.changeBtn = true;
          }
        });
      } else {
        this.txtSta = true;
        this.changeBtn = true;
      }
    },

    clear() {
      this.changeBtn = true;
    },

    userBtn(idx) {
      let list = [];
      list = JSON.parse(localStorage.getItem("userList"));
      if (list == null) {
        list = [];
      }
      list.push(idx == 1 ? this.userData : this.user);
      let res = new Map();
      let newList = list.filter(
        (list) => !res.has(list.id) && res.set(list.id, 1)
      );
      localStorage.setItem("userList", JSON.stringify(newList));
      if(idx == 2){
      this.addIdBtn();
      this.userShow = true;
      }
    },
    langBtn() {
      this.showBottom = true;
    },
    changeLang(item) {
      this.isLang = item.lang;
      localStorage.setItem("isLang", this.isLang);
      this.$i18n.locale = item.lang;
      this.showBottom = false;
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },

    changeUid(item) {
      this.targetUserId = item.id;
      this.changeData(this.targetUserId);
      this.listData();
      this.showCenter = false;
    },

    format(num) {
      return (num.toFixed(2) + "").replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        "$&,"
      );
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
html[lang="ar"] .box {
  direction: rtl;
}
html[lang="ar"] .labels-img {
  -webkit-transform: rotateY(180deg);
}
html[lang="ar"] .picnum {
  justify-content: left !important;
}

.box {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f6f8;
}

.head {
  height: 0.76rem;
  /* display: flex;
  align-items: center; */
  padding-top: 0.75rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  position: relative;
}
.pt025{
 padding-top: 0.25rem;
}
.picnumimg .labels-zt {
  text-align: center;
  line-height: 24px;
  margin: 0 5px;
}
.box-main {
  padding-left: 15px;
  padding-right: 15px;
}

.head img {
  width: 0.54rem;
}
/deep/.van-tabs__nav {
  background-color: #f5f6f8;
}
.head-left {
  z-index: 100;
  position: absolute;
  top: 0.9rem;
  left: 0.25rem;
}
.head-right {
  z-index: 100;
  position: absolute;
  top: 0.9rem;
  right: 0.25rem;
}
.top4{
  top: 0.4rem;
}
.head-top {
  font-size: 18px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  color: #000000;
}

.tab-css {
  width: 120px;
  text-align: center;
}

.head .title {
  line-height: 0.76rem;
  text-align: center;
}

.head .tab {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.user {
  height: 92px;
  font-size: 16px;
  margin: 15px 0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  background: #ffffff;
  box-sizing: border-box;
}

.user-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 0 10px;
}

.user .text {
  flex: 1;
  line-height: 25px;
}

.text-1 {
  width: 125px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 15px;
  color: #000000;
  word-wrap: break-word;
}

.text-2 {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
  margin-top: 5px;
}

.user-id {
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 2px;
}
.add-id {
  width: 90px;
  height: 27px;
  font-size: 12px;
  font-weight: 500;
  line-height: 27px;
  border-radius: 12px;
  color: #afa9b4;
  border: 1px solid #dfd9e3;
  font-family: "Montserrat";
  font-style: normal;
  text-align: center;
}
.balance {
  display: flex;
  align-items: center;
  margin-top: 5px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.balance-txt {
  /* 余额： */
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
}
.dio .diamond {
  max-width: 120px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.Diamonds {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.Diamonds-box {
  width: 48%;
  height: 68px;
  color: #000000;
  background: #ffffff;
  border-radius: 18px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-left: 3px;
  box-sizing: border-box;
}

.status {
  position: absolute;
  right: 5px;
  bottom: 5px;
}

.active {
  /* 主色 */
  border: 2px solid #8131e7;
}

.lable {
  display: block;
  /* width: 40px; */
  height: 24px;
  background: rgba(255, 78, 149, 1);
  text-align: center;
  border-radius: 18px 15px 15px 0px;
  position: absolute;
  top: 0;
  left: 0;

  /* 标签 */
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 24px;
  color: #ffffff;
}

.sizeimg {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}

.sizeimg-img {
  height: 28px;
  /* width: 28px; */
  margin-right: 3px;
}

.box-bottom {
  flex: 1;
  box-sizing: border-box;
  overflow-y: scroll;
  padding: 0 15px;
}

.bottom-list {
  height: 70px;
  background: #fff;
  border-radius: 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.bottom-image {
  width: 145px;
  height: 100%;
  display: flex;
  align-items: center;
  object-fit: cover;
}

.bottom-img {
  width: 116px;
  height: 46px;
  margin-left: 10px;
}

.picnum {
  flex: 1;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: right !important;
}

.picnumimg {
  height: 24px;
  width: 70px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
  border-radius: 15px;
  margin-right: 10px;
  background: rgba(255, 78, 149, 1);
}

.labels-text {
  /* width: 60px; */
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  color: #2a2b30;
  margin-right: 5px;
  display: inherit;
}
.text-css {
  font-family: "Poppins";
  font-weight: 400;
  font-size: 14px;
  color: #9c9eac;
}

.picnum-box {
  display: flex;
  align-items: center;
}

.triangle-right {
  height: 24px;
  display: block;
  border-style: solid;
  border-color: transparent;
  border-width: 12px 0 12px 9px;
  border-left-color: #ff7474;
}

.van-divider {
  margin: 0;
}

.labels-img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.change-uid {
  width: 92%;
  padding: 10px 20px;
  box-sizing: border-box;
}

.change-uid .title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 60px;
  text-align: center;
  color: #101010;
}

.add-uid {
  display: flex;
  align-items: center;
}

.add-uid img {
  width: 42px;
  height: 42px;
  margin-right: 20px;
}

.add-uid p {
  /* 新增UID */
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #000000;
}

.add-user {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.add-user img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 20px;
}
.add-user .tx1 {
  font-size: 14px;
  line-height: 17px;
  color: #000000;
}
.add-user .tx2 {
  font-size: 12px;
  line-height: 15px;
  color: #afa9b4;
}
.uid-ipt {
  height: 50px;
  font-weight: 400;
  font-size: 14px;
  line-height: 50px;
  text-align: center;
  color: #000000;
  border: 1px solid #000000;
  border-radius: 10px;
  font-family: "Montserrat";
  font-style: normal;
  padding: 0 20px;
}
.btn {
  width: 145px;
  height: 46px;
  background: #8131e7;
  border-radius: 14px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
}

.btn2 {
  width: 145px;
  height: 46px;
  border-radius: 14px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  background: #dfd9e3;
  color: #000000;
}
.newbtn {
  background: #8131e7;
  color: #ffffff;
}
.prompt {
  height: 35px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 35px;
  text-align: center;
}
.errtxt {
  color: rgba(255, 67, 101, 1);
}
.username {
  color: rgba(0, 0, 0, 1);
}

.showBottom {
  height: 55%;
  width: 96%;
  margin-left: 2%;
}
.van-popup--bottom.van-popup--round {
  border-radius: 16px;
}
.van-popup--bottom {
  bottom: 10px;
}
.lang-tit {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 60px;
  text-align: center;
  color: #101010;
}
/deep/.van-popup__close-icon {
  color: #000000;
  font-size: 18px;
}
/deep/.van-tabs--line .van-tabs__wrap {
  height: 0.75rem;
}
/deep/.van-tab {
  font-size: 15px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  width: 100px;
  -webkit-box-flex: none;
  -webkit-flex: none;
  flex: none;
}
/deep/.van-tabs__nav {
  justify-content: center;
}
.lang-css {
  height: 50px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #121212;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lang-css img {
  width: 20px;
  height: 14px;
}
/deep/.van-overlay {
  position: absolute;
}
.int {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #000000;
  padding: 0 15px;
}
</style>
